var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "wkb-graph-controls",
      attrs: { role: "toolbar", "aria-label": "Graph controls" },
    },
    [
      _c(
        "button",
        {
          staticClass: "wkb-graph-control-btn wkb-graph-control-btn--expand",
          attrs: {
            type: "button",
            title: "Expand KG",
            "aria-label": "Expand KG",
          },
          on: {
            click: function ($event) {
              return _vm.$emit("action", "expand")
            },
          },
        },
        [_c("b-icon", { attrs: { icon: "plus", "aria-hidden": "true" } })],
        1
      ),
      _c(
        "button",
        {
          staticClass: "wkb-graph-control-btn wkb-graph-control-btn--filter",
          attrs: {
            type: "button",
            title: "Visibility filters",
            "aria-label": _vm.visibilityFilterBadgeLabel,
          },
          on: {
            click: function ($event) {
              return _vm.$emit("action", "filter")
            },
          },
        },
        [
          _c("b-icon", {
            attrs: { icon: "funnel-fill", "aria-hidden": "true" },
          }),
          _vm.visibilityFilterCount > 0
            ? _c(
                "span",
                {
                  staticClass: "wkb-graph-control-badge",
                  attrs: { "aria-hidden": "true" },
                },
                [_vm._v(" " + _vm._s(_vm.visibilityFilterCount) + " ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "button",
        {
          staticClass: "wkb-graph-control-btn wkb-graph-control-btn--assistant",
          class: { "is-active": _vm.aiAssistantOpen },
          attrs: {
            type: "button",
            title: "Canvas assistant",
            "aria-label": "Canvas assistant",
            "aria-expanded": _vm.aiAssistantOpen ? "true" : "false",
          },
          on: {
            click: function ($event) {
              return _vm.$emit("action", "assistant")
            },
          },
        },
        [
          _c(
            "span",
            {
              staticClass: "wkb-graph-control-ai-label",
              attrs: { "aria-hidden": "true" },
            },
            [_vm._v("AI")]
          ),
        ]
      ),
      _c("div", { staticClass: "zoom-slider-outer" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.localZoom,
              expression: "localZoom",
              modifiers: { number: true },
            },
          ],
          staticClass: "zoom-slider",
          attrs: {
            id: _vm.zoomInputId,
            type: "range",
            min: _vm.zoomMin,
            max: _vm.zoomMax,
            step: _vm.zoomStep,
            disabled: _vm.disabled,
            "aria-label": "Graph zoom",
          },
          domProps: { value: _vm.localZoom },
          on: {
            input: _vm.onZoomInput,
            __r: function ($event) {
              _vm.localZoom = _vm._n($event.target.value)
            },
            blur: function ($event) {
              return _vm.$forceUpdate()
            },
          },
        }),
      ]),
      _c(
        "div",
        { staticClass: "wkb-graph-data-actions" },
        [
          _c(
            "button",
            {
              staticClass: "wkb-graph-control-btn",
              class: { "is-active": _vm.graphTableOpen },
              attrs: {
                type: "button",
                title: "Graph data table",
                "aria-label": "Graph data table",
                "aria-expanded": _vm.graphTableOpen ? "true" : "false",
                disabled: _vm.graphTableDisabled,
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("update:graphTableOpen", !_vm.graphTableOpen)
                },
              },
            },
            [_c("b-icon", { attrs: { icon: "table", "aria-hidden": "true" } })],
            1
          ),
          _c("WorkspaceGraphViewOptionsMenu", {
            attrs: {
              open: _vm.graphOptionsOpen,
              "hide-contextual-edges": _vm.hideContextualEdges,
              "hide-jumping-edges": _vm.hideJumpingEdges,
            },
            on: {
              "update:open": function ($event) {
                return _vm.$emit("update:graphOptionsOpen", $event)
              },
              "update:hideContextualEdges": function ($event) {
                return _vm.$emit("update:hideContextualEdges", $event)
              },
              "update:hideJumpingEdges": function ($event) {
                return _vm.$emit("update:hideJumpingEdges", $event)
              },
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }